import { InjectionToken } from '@angular/core';

/**
 * Storage abstraction for auth tokens. Two implementations:
 *  - WebTokenStore (PWA): access in memory, refresh stays in HttpOnly cookie (server-owned).
 *  - CapacitorTokenStore (native): access in memory, refresh in @capacitor/preferences.
 *
 * The factory in api-client.provider selects via Capacitor.isNativePlatform().
 */
export interface TokenStore {
  getAccessToken(): string | null;
  setAccessToken(token: string | null): void;
  // Refresh: Web returns null + no-ops (cookie is server-owned).
  getRefreshToken(): Promise<string | null>;
  setRefreshToken(token: string | null): Promise<void>;
  clear(): Promise<void>;
}

export const TOKEN_STORE = new InjectionToken<TokenStore>('TOKEN_STORE');
